import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { GET_ADDITIONAL_FURNITURE_DEFAULT_DETAILS_ACTION_TYPE,INSERT_UPDATE_ADDITIONAL_FURNITURE_ACTION_TYPE, headers, getDefaultFurnitureAgencyDetailsUrl,insertUpdateAdditionalFurnitureUrl } from "../../../../../utils/constants";

export const getDefaultFurnitureAgencyDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
        }
        const res = await axiosGet(getDefaultFurnitureAgencyDetailsUrl, params, headers)
        dispatch({
            type: GET_ADDITIONAL_FURNITURE_DEFAULT_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateAdditionalFurniture_action = (Remark, AdditionalFurnitureHdrID,AdditionalFurnitureList,ManualFormsID,
            ServiceID,
            VendorDetails) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AdditionalFurnitureHdrID: AdditionalFurnitureHdrID,
            ExhibitionID: parseInt(sessionStorage.getItem('sessionExhibitionID')),
            ExhRegistrationID: parseInt(sessionStorage.getItem('ExhRegistrationIDSS')),
            Remark: Remark,
            AdditionalFurnitureList: AdditionalFurnitureList,
            ManualFormsID:ManualFormsID,
            ServiceID:ServiceID,
            VendorDetails:VendorDetails
        }
        console.log("=== PARAMS BEING SENT TO API ===", params);
        const res = await axiosPost(insertUpdateAdditionalFurnitureUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_ADDITIONAL_FURNITURE_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}